import { Text } from '@chakra-ui/react'
import styled from '@emotion/styled'

import { getBackground, getBorderColor, getFontWeight, getTextColor } from './helpers'

export type DayStyleProps = {
  isToday: boolean
  isSelected: boolean
  isDisabled: boolean
}

export const StyledButton = styled.button<DayStyleProps>`
  width: 24px;
  height: 24px;
  position: relative;

  background: ${(props) => getBackground(props)};
  border: 2px solid ${(props) => getBorderColor(props)};
  border-radius: 50%;
  cursor: pointer;

  ${({ isDisabled }) => (isDisabled ? 'pointer-events: none;' : '')}
`

export const DayNumber = styled(Text)<DayStyleProps>`
  position: absolute;
  // top: calc(50% - 1px);
  left: 50%;
  transform: translate(-50%, -50%);

  color: ${(props) => getTextColor(props)};

  font-weight: ${(props) => getFontWeight(props)};
`
